import * as actions from 'redux/actions/keywords.actions'
import * as userActions from 'redux/actions/user.actions'
import * as accountActions from 'redux/actions/account.actions'

import getKeywordsWithNewKeyword from './keywordsHelpers/getKeywordsWithNewKeyword'

import updateKeywords from './keywordsHelpers/updateKeywords'
import failureKeywords from './keywordsHelpers/failureKeywords'
import { hasPropertyChain } from 'helpers/util'
import storage from 'helpers/storage'

const hideKeywordTags = storage.get('hideKeywordTags')

const initialState = {
  keywords: {},
  tagsHidden: hideKeywordTags === 'true' || hideKeywordTags === true
}

const keywordsReducer = (state = initialState, { type, payload = {} }) => {
  let keywords = state.keywords

  switch (type) {
    case actions.getKeywordSerpSuccess.type:
    case actions.getKeywordHistorySuccess.type:
      // create domain object if missing in domains
      if (!hasPropertyChain(keywords, payload.keywordId)) {
        keywords = getKeywordsWithNewKeyword(keywords, payload.keywordId)
      }
      return {
        ...state,
        keywords: updateKeywords(keywords, { type, payload })
      }
    case actions.getSerpHistory.type:
      return {
        ...state,
        focusSerpFeature: null,
        focusSerpFeatureDomainId: payload.domainId,
        focusSerpFeatureKeywordId: payload.keywordId
      }
    case actions.changeTagsVisibility.type:
      storage.set('hideKeywordTags', payload.tagsHidden)
      return {
        ...state,
        tagsHidden: payload.tagsHidden
      }
    case actions.getSerpHistorySuccess.type:
      return {
        ...state,
        focusSerpFeature: payload.data
      }
    case actions.getKeywordSerpFailure.type:
      return {
        ...state,
        keywords: failureKeywords(keywords, { type, payload })
      }
    case accountActions.getAccountDataFailure.type:
    case userActions.logout.type:
      return initialState
    default:
      return state
  }
}

export default keywordsReducer
